<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="py-6 px-6">
    <div>
      <nav class="sm:hidden" aria-label="Back">
        <a
          href="#"
          class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700"
        >
          <ChevronLeftIcon
            class="flex-shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400"
            aria-hidden="true"
          />
          Back
        </a>
      </nav>
      <nav class="hidden sm:flex" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center space-x-4">
          <li>
            <div class="flex">
              <router-link
                :to="'/settings'"
                class="text-sm font-medium text-gray-500 hover:text-gray-700"
                >Settings</router-link
              >
            </div>
          </li>
          <li>
            <div class="flex items-center">
              <ChevronRightIcon
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
              <a
                href="#"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >Account Settings</a
              >
            </div>
          </li>
        </ol>
      </nav>
    </div>

    <!-- Start  -->
    <div class="px-6">
      <div class="mt-4 bg-white shadow overflow-hidden sm:rounded-lg">
        <div class="px-4 py-5 sm:px-6">
          <div
            class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12 sm:w-full"
          >
            <div class="sm:col-span-6">
              <div class="flex">
                <p class="pr-3 text-lg leading-6 font-medium text-gray-900">
                  Webhook
                </p>
                <span
                  v-if="this.account.webhook.enabled"
                  class="px-3 inline-flex text-xs leading-5 rounded-full bg-green-100 text-gray-800"
                  >Enabled
                </span>
                <span
                  v-else
                  class="px-2 inline-flex text-xs leading-5 rounded-full bg-red-400 text-gray-100"
                  >Disabled
                </span>
              </div>

              <p class="mt-1 max-w-2xl text-sm text-gray-500">
                Define a server endpoint. Ensure server returns 200 to confirm
                connection
              </p>
            </div>
            <div class="sm:col-span-6 sm:text-right text-left">
              <button
                v-if="this.account.webhook.enabled"
                @click="disableWebhook"
                type="button"
                class="items-center mr-2 px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-small text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Disable
              </button>
              <button
                v-else
                type="button"
                @click="enableWebhook"
                class="items-center mr-2 px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-small text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Enable
              </button>
            </div>
          </div>
        </div>
        <div class="px-6 py-6 flex border-t sm:border-gray-200 sm:pt-5">
          <div
            class="mt-6 grid grid-cols-12 gap-y-6 gap-x-4 sm:grid-cols-12 sm:w-full"
          >
            <div class="flex sm:col-span-6 col-span-12">
              <span
                class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
              >
                https://
              </span>
              <input
                type="text"
                v-model="account.webhook.url"
                class="flex sm:w-full w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300"
              />
            </div>
            <div class="sm:col-span-1 col-span-3">
              <button
                type="button"
                @click="testWebhookURL"
                class="items-center mr-2 px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
              >
                Test
              </button>
            </div>

            <div class="sm:col-span-5 sm:text-right col-span-12 text-left">
              <div v-if="!saving">
                <button
                  type="button"
                  @click="updateWebhookURL"
                  class="items-center mr-2 px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                >
                  Update URL
                </button>
              </div>
              <div v-else>
                <button
                  type="button"
                  class="items-center mr-2 px-7 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white bg-green-50"
                >
                  Updated
                </button>
              </div>
            </div>
            <div class="flex sm:col-span-6 col-span-12">
              <div v-if="webhookStatus == 200" class="sm:col-span-1 col-span-2">
                <CheckCircleIcon
                  class="ml-2 h-5 w-5 text-green-400"
                  aria-hidden="true"
                />
              </div>
              <div
                v-else-if="webhookStatus == 0"
                class="sm:col-span-1 col-span-2"
              ></div>
              <div v-else class="sm:col-span-1 col-span-2">
                <XCircleIcon
                  class="ml-2 h-5 w-5 text-red-400"
                  aria-hidden="true"
                />
              </div>
              <p class="ml-4 px-0 text-sm font-small text-gray-500">
                {{ webhookMessage }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- API Key -->

    <div class="px-6">
      <div class="mt-4 bg-white shadow overflow-hidden sm:rounded-lg">
        <div class="px-4 py-5 sm:px-6">
          <div
            class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12 sm:w-full"
          >
            <div class="sm:col-span-6">
              <div class="flex">
                <p class="pr-3 text-lg leading-6 font-medium text-gray-900">
                  API Key
                </p>
              </div>

              <p class="mt-1 max-w-2xl text-sm text-gray-500">
                coreThings has an API key that allows you work directly with the
                API. More details on the API reference can be found at
                <a href="https://docs.corethings.io" target="new"
                  >https://docs.docs.corethings.io</a
                >
              </p>
            </div>
          </div>
        </div>
        <div class="px-6 py-6 flex border-t sm:border-gray-200 sm:pt-5">
          <div
            class="mt-6 grid grid-cols-12 gap-y-6 gap-x-4 sm:grid-cols-12 sm:w-full"
          >
            <div class="flex sm:col-span-6 col-span-12">
              <span
                class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
              >
                api_key
              </span>
              <input
                type="text"
                v-model="account.api_key"
                class="flex sm:w-full w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300"
              />
            </div>
            <div v-if="account.api_key" class="col-span-3">
              <div v-if="!saving_api_key">
                <button
                  type="button"
                  @click="generateAPIKey"
                  class="items-center mr-2 px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                >
                  Rotate Key
                </button>
              </div>
              <div v-else>
                <button
                  type="button"
                  class="items-center mr-2 px-7 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white bg-green-50"
                >
                  Updated
                </button>
              </div>
            </div>
            <div v-else class="col-span-3">
              <div v-if="!saving_api_key">
                <button
                  type="button"
                  @click="generateAPIKey"
                  class="items-center mr-2 px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                >
                  Generate Key
                </button>
              </div>
              <div v-else>
                <button
                  type="button"
                  class="items-center mr-2 px-7 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white bg-green-50"
                >
                  Updated
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <alert-banner v-if="$store.state.userAlert.visible"></alert-banner>
  <server-response :response="serverResponse"></server-response>
  <loading-widget v-if="showLoading"></loading-widget>
</template>

<script>
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/solid';
import { Switch } from '@headlessui/vue';
import axios from 'axios';
import LoadingWidget from '../../components/LoadingWidget.vue';
import ServerResponse from '../../components/ServerResponse';
import AlertBanner from '../../components/AlertBanner';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/vue/solid';
//import generateApiKey from 'generate-api-key';
import uuidAPIKey from 'uuid-apikey';

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    Switch,
    LoadingWidget,
    ServerResponse,
    AlertBanner,
    CheckCircleIcon,
    XCircleIcon,
  },
  data() {
    return {
      showLoading: false,
      saving: false,
      saving_api_key: false,
      webhookStatus: 0,
      webhookMessage: '',
      serverResponse: '',
      account: {
        webhook: {
          enabled: false,
          url: '',
        },
        api_key: '',
      },
    };
  },
  created() {
    const currentAccountSession = this.$store.state.account.name;
    axios
      .get('/accounts?account_name=' + currentAccountSession)
      .then((res) => {
        this.serverResponse = JSON.stringify(res, null, 2);
        this.account = res.data.data[0];

        console.log('this.account');
        console.log(this.account);

        //Let's test the webhook url as soon as we come in
        //but only if the webhook is enabled
        if (this.account.webhook.enabled == true) {
          this.testWebhookURL();
        }
      })
      .catch((err) => {
        this.raiseErrorAlert(err);
        this.serverResponse = JSON.stringify(err.response, null, 2);
      });
  },
  methods: {
    generateAPIKey() {
      this.saving_api_key = true;
      //this.account.api_key = generateApiKey({ method: 'uuidv4' });
      //this.account.api_key = 'hello-world';
      let key = uuidAPIKey.create();
      this.account.api_key = key.apiKey;

      console.log('api_key: ' + this.account.api_key);
      axios
        .put('/accounts/' + this.account._id, this.account)
        .then((res) => {
          this.serverResponse = JSON.stringify(res, null, 2);
          //Just to give some feeling of action to the user
          //Without this, it feels too quick and there's no sense of change
          setTimeout(() => {
            this.saving_api_key = false;
          }, 1000);
        })
        .catch((err) => {
          this.serverResponse = JSON.stringify(err.response, null, 2);
          //Just to give some feeling of action to the user
          //Without this, it feels too quick and there's no sense of change
          setTimeout(() => {
            this.saving_api_key = false;
          }, 1000);
        });
    },
    enableWebhook() {
      this.account.webhook.enabled = true;
      axios
        .put('/accounts/' + this.account._id, this.account)
        .then((res) => {
          this.serverResponse = JSON.stringify(res, null, 2);
        })
        .catch((err) => {
          this.serverResponse = JSON.stringify(err.response, null, 2);
        });
    },
    disableWebhook() {
      this.account.webhook.enabled = false;
      axios
        .put('/accounts/' + this.account._id, this.account)
        .then((res) => {
          this.serverResponse = JSON.stringify(res, null, 2);
        })
        .catch((err) => {
          this.serverResponse = JSON.stringify(err.response, null, 2);
        });
    },
    updateWebhookURL() {
      this.saving = true;
      axios
        .put('/accounts/' + this.account._id, this.account)
        .then((res) => {
          this.serverResponse = JSON.stringify(res, null, 2);
          //Just to give some feeling of action to the user
          //Without this, it feels too quick and there's no sense of change
          setTimeout(() => {
            this.saving = false;
          }, 500);
        })
        .catch((err) => {
          this.serverResponse = JSON.stringify(err.response, null, 2);
          setTimeout(() => {
            this.saving = false;
          }, 500);
        });
    },
    testWebhookURL() {
      this.showLoading = true;
      axios
        .post('/proxy/test-webhook-url', {
          webhook_url: this.account.webhook.url,
          test_data: { temperature_internal: 6.0 },
        })
        .then((res) => {
          //Just to give some feeling of action to the user
          //Without this, it feels too quick and there's no sense of change
          //console.log(res);
          this.webhookStatus = res.status;
          this.webhookMessage = res.status;
          this.serverResponse = JSON.stringify(res, null, 2);
          this.showLoading = false;
        })
        .catch((err) => {
          this.webhookStatus = 400;
          console.log(err);
          this.webhookMessage = err.response.data.data;
          this.serverResponse = JSON.stringify(err.response, null, 2);
          this.showLoading = false;
        });
    },
  },
};
</script>
